/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuthEmailWebRequest,
  ExamineBrandUserWebRequest,
  ExamineInvestorUserWebRequest,
  ResultBaseReturn,
  ResultExamineStatusResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ConUserTypeExamineWebController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags con-user-type-examine-web-controller
   * @name ConUserTypeExamineWebControllerV1AuthEmailUsingPost1
   * @summary 身份认证:邮箱认证
   * @request POST:/consumebrand/web/v1/conusertypeexamine/auth_email
   * @secure
   */
  conUserTypeExamineWebControllerV1AuthEmailUsingPost1 = (data: AuthEmailWebRequest, params: RequestParams = {}) =>
    this.request<ResultBaseReturn, void>({
      path: `/consumebrand/web/v1/conusertypeexamine/auth_email`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-user-type-examine-web-controller
   * @name ConUserTypeExamineWebControllerV1ExamineBrandUserUsingPost1
   * @summary 认证品牌方
   * @request POST:/consumebrand/web/v1/conusertypeexamine/brand_user
   * @secure
   */
  conUserTypeExamineWebControllerV1ExamineBrandUserUsingPost1 = (
    data: ExamineBrandUserWebRequest,
    params: RequestParams = {}
  ) =>
    this.request<ResultBaseReturn, void>({
      path: `/consumebrand/web/v1/conusertypeexamine/brand_user`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-user-type-examine-web-controller
   * @name ConUserTypeExamineWebControllerV1ExamineStatusUsingGet1
   * @summary 查询认证状态
   * @request GET:/consumebrand/web/v1/conusertypeexamine/examine_status
   * @secure
   */
  conUserTypeExamineWebControllerV1ExamineStatusUsingGet1 = (params: RequestParams = {}) =>
    this.request<ResultExamineStatusResponse, void>({
      path: `/consumebrand/web/v1/conusertypeexamine/examine_status`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-user-type-examine-web-controller
   * @name ConUserTypeExamineWebControllerV1ExamineInvestorUserUsingPost1
   * @summary 认证投资方
   * @request POST:/consumebrand/web/v1/conusertypeexamine/investor_user
   * @secure
   */
  conUserTypeExamineWebControllerV1ExamineInvestorUserUsingPost1 = (
    data: ExamineInvestorUserWebRequest,
    params: RequestParams = {}
  ) =>
    this.request<ResultBaseReturn, void>({
      path: `/consumebrand/web/v1/conusertypeexamine/investor_user`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
